import { useEffect } from "react";

import ReactPortal from "../../../../helpers/ReactPortal";
import MessageBoxCaptionBar from "./MessageBoxCaptionBar/MessageBoxCaptionBar";
import { PropsMessageBoxLayoutBase } from "../../modelsMessageBox";
import "./MessageBoxLayoutBase.scss";
import { useNotification } from "../../../../hooks/useNotification";

const MessageBoxLayoutBase = ({
    handleClose,
    children,
    stateWindow,
    captionButtons,
}: PropsMessageBoxLayoutBase) => {
    const { clearNotification } = useNotification();

    useEffect(() => {
        const closeOnEscapeKey = async (e: any) => {
            if (e.key === "Escape") {
                await clearNotification("no").then(() => {
                    handleClose("no");
                });
            }
        };
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return () => {
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [handleClose, clearNotification]);

    return (
        <ReactPortal wrapperId="message_box__body">
            <div
                id="BACKDROP"
                className="message_box__backdrop"
                onClick={async (e: any) => {
                    if (e.target.id === "BACKDROP") {
                        await clearNotification("no");
                        handleClose("no");
                    }
                }}
            >
                <div className="message_box__window">
                    {stateWindow && (
                        <div className="message_box__state_line">
                            <div
                                className="message_box__state_line_filler"
                                state-window={stateWindow}
                            ></div>
                        </div>
                    )}
                    <MessageBoxCaptionBar
                        handleClose={handleClose}
                        captionButtons={captionButtons}
                    />
                    {children}
                </div>
            </div>
        </ReactPortal>
    );
};

export default MessageBoxLayoutBase;
